import React from 'react';
import AbstractView from '../../src/components/_views/AbstractView';
import {CardBody} from 'reactstrap';
import Translate from '../../src/components/Translate/Translate';
import AuthLoginForm from '../../src/containers/_forms/AuthLoginForm/AuthLoginForm';
import {IReduxUserState} from '../../src/@interfaces';
import NonAuthLayout from '../../src/components/_layouts/NonAuthLayout/NonAuthLayout';

export default class AuthLogin extends AbstractView<IReduxUserState> {
    static layout = NonAuthLayout;
    protected static pageTitle = 'AuthLogin.page-title';

    protected authorize(): boolean {
        return !this.props.model;
    }

    protected renderContent(): React.ReactNode {
        return <div className="auth-login">
            <div className="auth-login__header">
                <Translate message="AuthLogin.header-title" tag="h5"/>
                <Translate message="AuthLogin.header-description" tag="p"/>
            </div>

            <CardBody className="pt-0">
                <div className="auth-login__avatar-block">
                    <span className="auth-login__avatar">
                        LOGO
                    </span>
                </div>

                <div className="mb-3">
                    <AuthLoginForm/>
                </div>
            </CardBody>
        </div>;
    }
}
